
import { useState, useEffect } from 'react';

export const usePWAInstall = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Detecta se já está rodando como PWA (standalone)
        if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
            setIsInstalled(true);
        }

        const handler = (e) => {
            // Impede o mini-infobar padrão do navegador
            e.preventDefault();
            // Guarda o evento para disparar depois
            setDeferredPrompt(e);
            setIsInstallable(true);
            console.log("PWA: Evento beforeinstallprompt capturado.");
        };

        window.addEventListener('beforeinstallprompt', handler);

        const appInstalledHandler = () => {
            setIsInstallable(false);
            setDeferredPrompt(null);
            setIsInstalled(true);
            console.log("PWA: Aplicativo instalado com sucesso!");
        };

        window.addEventListener('appinstalled', appInstalledHandler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
            window.removeEventListener('appinstalled', appInstalledHandler);
        };
    }, []);

    const installPWA = async () => {
        if (!deferredPrompt) return false;

        // Mostra o prompt nativo
        deferredPrompt.prompt();

        // Espera a resposta do usuário
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`PWA: Escolha do usuário: ${outcome}`);

        // Limpa o prompt, só pode ser usado uma vez
        setDeferredPrompt(null);
        setIsInstallable(false);

        return outcome === 'accepted';
    };

    return { isInstallable, isInstalled, installPWA };
};
